import gql from 'graphql-tag'

import { main, immutable } from './fragments'

export default gql`
mutation createLoyaltyCard($fields: LoyaltyCardFields) {
	cashAssist {
		createMutation: createLoyaltyCard(fields: $fields) {
			id: idTemp
			mod_ver
			...immutable
			...loyaltyCardMain
		}
	}
}
${immutable}
${main}`
